import React from 'react';
import { number } from 'prop-types';
import { connect } from 'react-redux';

const EstimatedCost = ({ cost }) => {
  return (
    <div className="ie--target--cost">
      <div>
        <span className="ie--target--cost--label">Estimated Cost:</span>
        <span className="ie--target--cost--value">$ {cost}</span>
      </div>
    </div>
  );
};

EstimatedCost.propTypes = {
  cost: number,
};

EstimatedCost.defaultProps = {
  cost: 0,
};

const mapStateToProps = ({ turnkeyOmnibus }) => {
  const { surveyInfo } = turnkeyOmnibus;
  return {
    cost: surveyInfo.estimatedCost,
  };
};


export default connect(
  mapStateToProps,
  null
)(EstimatedCost);
